import { Table, type TableProps } from "antd";

const StyledTable = <T extends object>(props: TableProps<T>) => (
  <Table
    {...props}
    className={`custom-table ${props.className || ""}`}
    pagination={
      props.pagination === false ? false : { pageSize: 5, ...props.pagination }
    }
    rowKey={props.rowKey || "key"}
    bordered
    rowClassName={(_, index) => (index % 2 === 0 ? "even-row" : "odd-row")}
  />
);

export default StyledTable;
